import axios from 'axios';
import configData from '../Config';

export const loadAssets = (project, state, dispatch) => {
    if (project.assets.length !== 0) {
        console.log('Assets found in state');
        return;
    }

    console.log('Trying to get assets');

    const data = {
        projectuserid: project.projectuserid,
        projectid: project.projectid,
        archived: project.archived,
    };

    axios.post(
        configData.CONTROLLERURL + configData.GETASSETS,
        data,
        {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=UTF-8",
                userid: state.user.userid,
                usertoken: state.user.usertoken
            }
        }
    )
        .then((res) => {
            console.log('Get assets data received');
            console.log(res.data)
            if (Array.isArray(res.data)) {
                dispatch({
                    type: 'ADD_ASSETS',
                    assets: res.data
                });
            }
        })
        .catch(() => { });
};

export const loadStructure = (project, state, dispatch) => {
    if (project.structure.length !== 0) {
        console.log('Structure found in state');
        return;
    }

    console.log('Trying to get structure');

    const data = {
        projectuserid: project.projectuserid,
        projectid: project.projectid,
        archived: project.archived,
    };

    axios.post(
        configData.CONTROLLERURL + configData.GETSTRUCTURE,
        data,
        {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=UTF-8",
                userid: state.user.userid,
                usertoken: state.user.usertoken
            }
        }
    )
        .then((res) => {
            console.log('Get structure data received');
            console.log(res.data)
            if (Array.isArray(res.data)) {
                dispatch({
                    type: 'ADD_STRUCTURE',
                    structure: res.data
                });
            }
        })
        .catch(() => { });
};

export const loadReadings = (project, state, dispatch) => {
    if (project.readings.length !== 0) {
        console.log('Readings found in state');
        return;
    }

    console.log('Trying to get readings');

    const data = {
        projectuserid: project.projectuserid,
        projectid: project.projectid,
        archived: project.archived,
    };

    axios.post(
        configData.CONTROLLERURL + configData.GETREADINGS,
        data,
        {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=UTF-8",
                userid: state.user.userid,
                usertoken: state.user.usertoken
            }
        }
    )
        .then((res) => {
            console.log('Get readings data received');
            console.log(res.data)
            if (Array.isArray(res.data)) {
                dispatch({
                    type: 'ADD_READINGS',
                    readings: res.data
                });
            }
        })
        .catch(() => { });
};